import React, { Suspense, lazy } from 'react';

import BackNavbar from '../components/navbar/BackNavbar';
import SearchBar from '../components/navbar/SearchBar';
import GolfCourseOverview from '../components/programmatic/golfCourse/GolfCourseOverview';

const HorizontalNewsletterSignup = lazy(() =>
  import('../components/blog/HorizontalNewsletterSignup'),
);
const Footer = lazy(() => import('../components/footer/Footer'));

//Helmet managed in the child
function GolfCoursePage() {
  return (
    <div>
      <BackNavbar />
      <SearchBar />
      <GolfCourseOverview />
      <hr></hr>
      <Suspense fallback={null}>
        <HorizontalNewsletterSignup />
      </Suspense>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
}

export default GolfCoursePage;
